import script from "./BodySubReviewPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./BodySubReviewPopup.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./BodySubReviewPopup.vue?vue&type=style&index=0&id=39e01ee8&module=tooltip&lang=css"
cssModules["tooltip"] = style0
import "./BodySubReviewPopup.vue?vue&type=style&index=1&id=39e01ee8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules],['__scopeId',"data-v-39e01ee8"]])

export default __exports__
import QRating from 'quasar/src/components/rating/QRating.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QRating});
